import React from 'react';
import LayoutRenderer from '../components/LayoutRenderer';
import { useLayout } from '../hooks/useLayout';
import { DEFAULT_LAYOUTS } from '../data/defaultLayouts';

export default function HomePage() {
  const { blocks } = useLayout('home', DEFAULT_LAYOUTS.home);
  return (
    <div data-testid="homepage">
      <LayoutRenderer blocks={blocks} />
    </div>
  );
}
